import { useQuery } from '@apollo/client';
import { updateClassSlice } from 'src/operations/store';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

export const useQueryProxy = (query, data) => {
  const dispatch = useDispatch();
  const response = useQuery(query, data);
  const companyName = response.data?.me ? response.data.me.company_name || 'default' : null;
  useEffect(() => {
    if (companyName !== null) dispatch(updateClassSlice(companyName));
  }, [companyName, dispatch]);
  useEffect(() => {
    if (window.Android?.SaveUserData && response.data) {
      window.Android.SaveUserData(JSON.stringify(response.data));
    }
  }, [response.data]);

  return response;
};
